import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Autocomplete } from "@mui/material";
import TextField from "@material-ui/core/TextField";
import { MenuWithBreadScrum } from "../../menu/MenuWithBreadScrum";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { InputAdornment } from "@mui/material";
import { Buffer } from "buffer";
import Button from "@material-ui/core/Button";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import _ from "lodash";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import "../MISReports.css";
import Pagination from "../../assetTracking/Pagination";
import Utils from "../../../provider/Utils";
class AssetPlanReportAnalysis extends Component {
  header = store.getState().header.header;
  breadCrumb = [
    { pageid: "/reports", uiname: "MIS Reports" },
    { pageid: "", uiname: "Asset Plan Analytics" },
  ];
  constructor() {
    super();
    this.state = {
      selectedTab: 0,
      searchText: "",
      initialPage: 0,
      pageSize: 10,
      pageNo: 0,
      showPerPage: 10,
      totalPages: 0,
      totalRecords: 0,
      assetSearchText: "",
      assetInitialPage: 0,
      assetPageSize: 10,
      assetPageNo: 0,
      assetShowPerPage: 10,
      assetTotalPages: 0,
      assetTotalRecords: 0,
      customerId: "",
      returnablePlanId: "",
      customer: null,
      returnablePlan: null,
      customerList: [],
      returnablePlanList: [],
      trackingHistoryList: [],
      render: false,
    };
    this.getCustomerList();
    this.debouncedGetAssetList = _.debounce(this.getPlanAssetList, 800);
  }

  getCustomerList() {
    const postObject = {
      header: this.header,
    };
    FetchServerData.callPostService(
      "/costomerms/getActiveList",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let customerListArray = output.data.customerList;
        // let allCustomer = {
        //   name: "All",
        // };
        // const customerList = [allCustomer, ...customerListArray];
        if (customerListArray.length > 0) {
          this.getCustomerPlanList(customerListArray[0]);
        }
        this.setState({
          customer: customerListArray[0],
          customerList: customerListArray,
        });
      }
    });
  }

  handleCustomerTypeChange(selectedCustomer) {
    this.getCustomerPlanList(selectedCustomer);
    this.setState({
      customer: selectedCustomer,
      customerId: selectedCustomer.id,
    });
  }
  handleReturnablePlanChange(selectedPlan) {
    this.getPlanAssetList(
      selectedPlan?.id,
      this.state.assetPageNo,
      this.state.assetPageSize,
      this.state.assetSearchText
    );
    this.getTrakingHistoryList(
      selectedPlan?.id,
      this.state.pageNo,
      this.state.pageSize,
      this.state.searchText
    );
    this.setState({
      returnablePlan: selectedPlan,
      returnablePlanId: selectedPlan.id,
    });
  }

  getCustomerPlanList(customer) {
    console.log(customer);
    const postObject = {
      header: this.header,
      customerId: customer?.id,
    };
    FetchServerData.callPostService(
      "/planAnalyticms/getCustomerPlanList",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let returnablePlanList = output.data;
        if (returnablePlanList.length > 0) {
          this.getPlanAssetList(
            returnablePlanList[0].id,
            this.state.assetPageNo,
            this.state.assetPageSize,
            this.state.assetSearchText
          );

          this.getTrakingHistoryList(
            returnablePlanList[0].id,
            this.state.pageNo,
            this.state.pageSize,
            this.state.searchText
          );
        }
        this.setState({
          returnablePlan: returnablePlanList[0],
          returnablePlanId: returnablePlanList[0].id,
          returnablePlanList: returnablePlanList,
        });
      }
    });
  }

  getPlanAssetList(returnablePlanId, pageNo, pageSize, searchText) {
    const postObject = {
      header: this.header,
      returnablePlanId: returnablePlanId,
      page: {
        searchText: searchText,
        pageNo: pageNo,
        pageSize: pageSize,
      },
    };
    FetchServerData.callPostService(
      "/planAnalyticms/getPlanAssetList",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let planAssetList = output.data.assetList;
        let page = output.data.page;
        this.setState({
          planAssetList: planAssetList,
          assetPageNo: page?.pageNo,
          assetShowPerPage: page?.pageSize,
          assetTotalPages: page?.totalPages,
          assetTotalRecords: page?.total,
        });
      }
    });
  }

  setKey(tab) {
    this.setState({
      selectedTab: tab,
      pageNo: 0,
      pageSize: 10,
    });
  }

  assetOnPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.assetPageNo + counter;
    let pageSize = returnProp.showPerPage;
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.setState({
      assetPageNo: currentPageIndex,
      assetShowPerPage: pageSize,
    });
    this.getPlanAssetList(
      this.state.returnablePlanId,
      currentPageIndex,
      pageSize
    );
    this.debouncedGetPlanAssetList = _.debounce(this.getPlanAssetList, 800);
  }

  onAssetSearchTextChange(e) {
    const search = e.target.value;
    this.setState({ assetSearchText: search });
    this.debouncedGetPlanAssetList(
      this.state.returnablePlanId,
      this.state.assetPageNo,
      this.state.assetPageSize,
      search
    );
  }

  getTrakingHistoryList(returnablePlanId, pageNo, pageSize) {
    const postObject = {
      header: this.header,
      returnablePlanId: returnablePlanId,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo,
        pageSize: pageSize,
      },
    };
    FetchServerData.callPostService(
      "/planAnalyticms/getPlanTrackingHistory",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let trackingHistoryData = output.data;
        for (let i = 0; i < trackingHistoryData.history.length; i++) {
          trackingHistoryData.history[i].selectedTrack = false;
        }
        this.setState({
          render: true,
          trackingHistoryList: trackingHistoryData.history,
          searchText: trackingHistoryData.page.searchText,
          pageNo: trackingHistoryData.page.pageNo,
          showPerPage: trackingHistoryData.page.pageSize,
          totalPages: trackingHistoryData.page.totalPages,
          totalRecords: trackingHistoryData.page.total,
        });
      }
    });
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.setState({
      pageNo: currentPageIndex,
      showPerPage: pageSize,
    });
    this.getPlanAssetList(
      this.state.returnablePlanId,
      currentPageIndex,
      pageSize
    );
    this.debouncedGetPlanAssetList = _.debounce(this.getPlanAssetList, 800);
  }

  onSearchTextChange(e) {
    const search = e.target.value;
    this.setState({ searchText: search });
    this.debouncedGetPlanAssetList(
      this.state.returnablePlanId,
      this.state.pageNo,
      this.state.pageSize,
      search
    );
  }

  toAssetDetails(assetId) {
    console.log(this.state.id);
    this.props.navigate("/asset", {
      state: {
        action: "view",
        assetId: assetId,
        assetCycleId: this.state.assetCycleId,
        returnablePlanId: this.state.id,
        pageId: "returnablePlanReport",
      },
    });
  }

  toAssetTrakingDetails(assetId) {
    this.props.navigate("/asset", {
      state: {
        // categoryId: this.state.categoryId,
        action: "view",
        assetId: assetId,
        replace: true,
        pageId: "assetTrackHistoryReport",
      },
    });
  }

  downloadPlanReport() {
    const postObject = {
      header: this.header,
      returnablePlanId: this.state.returnablePlanId,
    };

    FetchServerData.callPostService(
      "/planAnalyticms/downloadPlanReport",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        const byteArray = new Buffer(
          output.data.data.replace(/^[\w\d;:\/]+base64\,/g, ""),
          "base64"
        );
        const outputFilename = output.data.fileName;
        const url = URL.createObjectURL(new Blob([byteArray]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", outputFilename);
        document.body.appendChild(link);
        link.click();
      }
    });
  }

  render() {
    console.log(this.state.customerList);
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          navigate={this.props.navigate}
          domainObject="Asset Plan Analytics"
          name="Asset Plan Analytics"
        />
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <div className="row d-flex">
                  <div className="col-md-4" id="assetFormLabel">
                    <label
                      className="form-label "
                      htmlFor="collapsible-supplierType"
                    >
                      Customer <span className="asterisk"> *</span>
                    </label>
                    <Autocomplete
                      fullWidth
                      disableClearable
                      id="customerTypeList"
                      options={this.state.customerList}
                      value={this.state.customer}
                      defaultValue={this.state.customer}
                      getOptionLabel={(option) => option.name}
                      onChange={(event, value) => {
                        this.handleCustomerTypeChange(value);
                      }}
                      inputprops={{
                        style: { textTransform: "capitalize" },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Please Select"
                          variant="outlined"
                          required
                        />
                      )}
                    />
                  </div>
                  <div className="col-md-4" id="assetFormLabel">
                    <label
                      className="form-label "
                      htmlFor="collapsible-supplierType"
                    >
                      Returnable Plan <span className="asterisk"> *</span>
                    </label>
                    <Autocomplete
                      fullWidth
                      disableClearable
                      id="customerTypeList"
                      options={this.state.returnablePlanList}
                      value={this.state.returnablePlan}
                      defaultValue={this.state.returnablePlan}
                      getOptionLabel={(option) => option.name}
                      onChange={(event, value) => {
                        this.handleReturnablePlanChange(value);
                      }}
                      inputprops={{
                        style: { textTransform: "capitalize" },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Please Select"
                          variant="outlined"
                          required
                        />
                      )}
                    />
                  </div>
                  <div className="col-md-4" id="assetFormLabel">
                    <Button
                      variant="contained"
                      size="small"
                      id="excelBtn"
                      startIcon={<i class="fa fa-download"></i>}
                      onClick={(e) => this.downloadPlanReport()}
                    >
                      Download Excel
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <Tabs
            defaultIndex={this.state.selectedTab}
            onSelect={(k) => this.setKey(k)}
            className="reportReturnableTabs"
          >
            <TabList
              style={{ listStyle: "none" }}
              className="text-start d-flex justify-content-start ps-0"
            >
              <Tab className="reportReturnableTab hoverTab">Assets</Tab>
              <Tab className="reportReturnableTab hoverTab">
                Tracking History
              </Tab>
            </TabList>
            <TabPanel>
              <div className="row">
                <div className="col md-12">
                  <div className="card">
                    <div className="row justify-content-between p-2">
                      <div className="d-flex col-12 col-lg-4 col-xl-4">
                        <div className="col-12 text-start totalResults">
                          <span>
                            Total Results: {Utils.formatIndianNumber(this.state.assetTotalRecords)}
                          </span>
                        </div>
                      </div>
                      <div className="d-flex col-12 col-lg-8 col-xl-8">
                        <div className="col-12 text-end">
                          <>
                            <TextField
                              id="standard-search"
                              placeholder="Search"
                              type="search"
                              variant="standard"
                              value={this.state.assetSearchText}
                              onChange={this.onAssetSearchTextChange.bind(this)}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={this.getPlanAssetList.bind(
                                        this,
                                        this.state.returnablePlanId,
                                        this.state.assetPageNo,
                                        this.state.assetPageSize,
                                        this.state.assetSearchText
                                      )}
                                    >
                                      <SearchIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive paginationTable">
                      <table className="table text-start table-hover">
                        <thead className="paginationTableThead">
                          <tr>
                            <th scope="col fw-bold">Asset Name</th>
                            <th scope="col fw-bold">Asset UID</th>
                            <th scope="col fw-bold">Asset Code</th>
                            <th scope="col fw-bold">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.planAssetList?.map((rowData, index) => (
                            <tr
                              key={index}
                              style={{
                                backgroundColor:
                                  rowData.id === this.state.assetId
                                    ? "#e6effc"
                                    : "#fff",
                                cursor: "pointer",
                              }}
                            >
                              <td
                                style={{ width: "22%" }}
                                onClick={this.toAssetDetails.bind(
                                  this,
                                  rowData.id
                                )}
                              >
                                {rowData.name}
                              </td>
                              <td
                                style={{ width: "22%" }}
                                onClick={this.toAssetDetails.bind(
                                  this,
                                  rowData.id
                                )}
                              >
                                {rowData.uid}
                              </td>
                              <td
                                style={{ width: "22%" }}
                                onClick={this.toAssetDetails.bind(
                                  this,
                                  rowData.id
                                )}
                              >
                                {rowData.assetcode}
                              </td>
                              <td
                                style={{ width: "22%" }}
                                onClick={this.toAssetDetails.bind(
                                  this,
                                  rowData.id
                                )}
                              >
                                {rowData.status}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {this.state.assetTotalRecords === 0 && (
                      <div className="row text-center p-2">
                        <h5>Data not Available</h5>
                      </div>
                    )}
                    {this.state.assetTotalRecords > 10 && (
                      <div className="row justify-content-between pagination p-2">
                        <div className="pageSize col-4 text-start">
                          Page {this.state.assetPageNo + 1} of{" "}
                          {this.state.assetTotalRecords}
                        </div>
                        <div className="col-4 text-end">
                          <Pagination
                            showPerPage={this.state.assetShowPerPage}
                            onPaginationChange={this.assetOnPaginationChange.bind(
                              this
                            )}
                            total={this.state.assetTotalRecords}
                            pageNo={this.state.assetPageNo}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="row">
                <div className="col md-12">
                  <div className="card">
                    <div className="row justify-content-between p-2">
                      <div className="d-flex col-12 col-lg-4 col-xl-4">
                        <div className="col-12 text-start totalResults">
                          <span>Total Results: {Utils.formatIndianNumber(this.state.totalRecords)}</span>
                        </div>
                      </div>
                      <div className="d-flex col-12 col-lg-8 col-xl-8">
                        <div className="col-12 text-end">
                          <TextField
                            id="standard-search"
                            placeholder="Search"
                            type="search"
                            variant="standard"
                            value={this.state.searchText}
                            onChange={this.onSearchTextChange.bind(this)}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={this.getTrakingHistoryList.bind(
                                      this,
                                      this.state.returnablePlanId,
                                      0,
                                      this.state.showPerPage,
                                      this.state.searchText
                                    )}
                                  >
                                    <SearchIcon />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive paginationTable">
                      <table className="table text-start table-hover">
                        <thead className="paginationTableThead">
                          <tr>
                            <th scope="col fw-bold">#</th>
                            <th scope="col fw-bold">Plan Name</th>
                            <th scope="col fw-bold">Asset Name</th>
                            <th scope="col fw-bold">Asset UID</th>
                            <th scope="col fw-bold">Asset Code</th>
                            <th scope="col fw-bold">Action</th>
                            <th scope="col fw-bold">First Track Date</th>
                            <th scope="col fw-bold">Latest Track Date</th>
                            <th scope="col fw-bold">Location </th>
                            <th scope="col fw-bold">Count</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.trackingHistoryList?.map(
                            (rowData, index) => (
                              <tr
                                key={index}
                                style={{
                                  backgroundColor:
                                    rowData.assetid === this.state.assetId
                                      ? "#FEF5E7"
                                      : "#fff",
                                }}
                              >
                                <td>
                                  {this.state.pageNo * this.state.showPerPage +
                                    index +
                                    1}
                                </td>
                                <td style={{ width: "260px" }}>
                                  {rowData.planName}
                                </td>
                                <td style={{ width: "260px" }}>
                                  {rowData.assetname}
                                </td>
                                <td
                                  className="assetUID"
                                  style={{ width: "250px" }}
                                >
                                  <a
                                    // href="#"
                                    onClick={this.toAssetDetails.bind(
                                      this,
                                      rowData.assetid
                                    )}
                                    style={{
                                      color: "blue",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {rowData.assetuid}
                                  </a>
                                </td>
                                <td style={{ width: "200px" }}>
                                  {rowData.assetcode}
                                </td>
                                <td style={{ width: "30px" }}>
                                  {rowData.action}
                                </td>
                                <td style={{ width: "230px" }}>
                                  {Utils.getUtcToLocalDateTime(rowData.tdate)}
                                </td>
                                <td style={{ width: "230px" }}>
                                  {Utils.getUtcToLocalDateTime(
                                    rowData.tenddate
                                  )}
                                </td>
                                <td style={{ width: "480px" }}>
                                  {rowData.location ? rowData.location : ""}
                                </td>
                                <td style={{ width: "20px" }}>
                                  {rowData.count}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                    {this.state.totalRecords === 0 && (
                      <div className="row text-center p-2">
                        <h5>Data not Available</h5>
                      </div>
                    )}
                    {this.state.totalRecords > this.state.pageSize && (
                      <div className="row justify-content-between pagination p-1">
                        <div className="d-flex col-12 col-lg-4 col-xl-4">
                          <div className="pageSize col-12 text-start">
                            Page {this.state.pageNo + 1} of{" "}
                            {this.state.totalPages}
                          </div>
                        </div>
                        <div className="d-flex col-12 col-lg-8 col-xl-8">
                          <div className="col-12 text-end">
                            <Pagination
                              showPerPage={this.state.showPerPage}
                              onPaginationChange={this.onPaginationChange.bind(
                                this
                              )}
                              total={this.state.totalRecords}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </TabPanel>
          </Tabs>
        </div>
      </>
    );
  }
}
export default withRouter(AssetPlanReportAnalysis);
